import axios from 'axios';

const baseURL = process.env.REACT_APP_BASE_URL;

/** Settings loaded once for public layout (Header + Footer). */
export const PUBLIC_SITE_SETTING_KEYS = [
    'linkedin',
    'youtube',
    'pricing-admin-setting',
];

/**
 * Fetches multiple site settings in one request.
 * @param {string[]} keys
 * @returns {Promise<Record<string, object>>}
 */
export const fetchSiteSettingsByKeys = async (keys) => {
    const response = await axios.get(`${baseURL}/site-settings/bulk`, {
        params: { keys: keys.join(',') },
    });

    return response.data.data || {};
};
